import React, {createContext, useState, useEffect} from 'react';

import {useParams} from "react-router-dom";
import {getProject, getProjectUserRoles} from "../api/project";
import {ProjectType, ProjectUserRolesType, SubProjectRolesType} from "../types";
import UserRoles from "../utils/roles";

const ProjectContext = createContext<{id:number|null,name:string,userRoles:UserRoles|undefined|null, 
                        reportingDuration: ProjectType["reporting_duration"] | undefined | null, 
                        logo: string|null,
                        subProjectsMeta: ProjectType["sub_projects"] | undefined | null}>({id: null, name: "",userRoles:null , reportingDuration: null, subProjectsMeta: null,logo: null});

const ProjectProvider = ({children}: any) => {
    let {projectId} = useParams();
    const [project, setProject] = useState<{ id: null|number, name: string, logo: string|null }>({id: null, name: "", logo: null});
    const [userRoles, setUserRoles] = useState<UserRoles|null>(null);
    const [reportingDuration, setreportingDuration] = useState<ProjectType["reporting_duration"]|null>(null);
    const [subProjectsMeta, setSubProjectsMeta] = useState<ProjectType["sub_projects"]|null>(null);

    useEffect(() => {
        const getProjectData = async () => {
            const project = await getProject(projectId);
            setProject({id: project.id, name: project.name, logo: project.logo});
            setreportingDuration(project.reporting_duration)
            setSubProjectsMeta(project.sub_projects)
            
            const userProjectRolesData = await getProjectUserRoles(projectId);
            const userRoles=new UserRoles(userProjectRolesData)

            setUserRoles(userRoles)
        }
        getProjectData();
    }, [projectId]);



    return (
        <ProjectContext.Provider value={{...project, userRoles, reportingDuration, subProjectsMeta}}>
            {children}
        </ProjectContext.Provider>
    );
}


export {ProjectProvider};
export default ProjectContext;